import styled from "styled-components";

export const ButtonContainer = styled.div`
  position: relative;
  display: inline-block;
  padding: 15px 20px;
  background-color: white;
  color: black;
  border: 1px solid black;
  cursor: pointer;
  overflow: hidden;
  border-radius: 30px;
  font-size: 20px;
  font-family: Avenir Next;
  text-align: left;
  &:hover {
    background-color: black;
    color: white;
    transition: ease-in 0.2s;
  }
`;
